module.exports = __webpack_public_path__ + "static/media/bi3.94a35dfc.png";